module.exports = __webpack_public_path__ + "media/Hörbuch_Auszug.6910a33c.mp3";